import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";
import tableData from "DBTables/commessa.json"

import FileSystemCommessa from "./fileSystemCommessa.js"
import DettaglioCommessa from "./recapCommessa.js"

import * as ajax from "helpers/ajax";

import { ROLES } from "constant"
import { CHECKLIST_COMMESSA } from "../../constant.js";


export default class Commessa extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            commessaSelected: null,
            openFileSystem: false,
            openDetail:false,
        };
        this.ref = null;
    }

    componentDidMount = () => {
        //console.log(global.workers)
    }

    deleteWorkers = (data) => {
        let id = [];
        global.workers.data.map((el) => {
            if (el.commessa) {
                if (el.commessa.id == data.data.id) {
                    id.push(el.id)
                }
            }

        })

        id.map((el) => {
            ajax.ajaxDeleteStrapi("operai-commesses/" + el)
        })
    }

    createFileSystem = (data) => {
        let formData = new FormData();
        formData.append("id", data.data.id)
        ajax.ajaxPost("/file_create_commessa.php", formData)
        
    }

    openFileSystem = (data) => {
        this.setState({ openFileSystem: true, commessaSelected: data });
    }

    openDetail = (data) => {
        this.setState({ openDetail: true, commessaSelected: data });
    }

    createChecklist = (data) => {
        CHECKLIST_COMMESSA.map((el) => {
            let formdata = {}
            formdata["name"] = el.name;
            formdata["type"] = el.type;
            formdata["commessa"] = data.data.id;
            formdata = { "data": formdata };
            ajax.ajaxPostStrapi("commessa-checklists", formdata)
        })
    }

    checkMoveToFinished = (data, oldData) => {
        let result = true;
        if (data.stato == "finito" && oldData.stato != "finito") {
            data.commessa_checklists.map((el) => {
                if (!el.completed && el.needed) {
                    result = false;
                }
            })
        }

        if (!result) {
            this.ref?.errorRef("Impossibile spostare in stato finito, finche tutta la documentazione non viene caricata")
        }

        return result
    }

    render() {
        if (this.state.commessaSelected && this.state.openFileSystem) {
            return <FileSystemCommessa data={this.state.commessaSelected} backFunction={() => this.setState({ commessaSelected: null, openFileSystem: false })} />
        }

        if (this.state.commessaSelected && this.state.openDetail) {
            return <DettaglioCommessa data={this.state.commessaSelected} backFunction={() => this.setState({ commessaSelected: null, openFileSystem: false })} />
        }

        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={"Dashboard Commesse"}
                    subtitle={"Vista globale dell'andamento delle Commesse"}
                    icon={"house"}
                    backButton={this.props.backFunction}

                />

                <MDBox>
                    <MyDataTable
                        ref={(ref)=>this.ref=ref}
                        tableData={tableData}
                        filters={"&filters[commessa_madre]&populate=preventivis&populate=fattures&populate=gara&populate=commessa_madre&populate=incarichi.*&populate=incarichi.commessa_madre&populate=incarichi.fattures&populate=gara.gara_checklists&populate=commessa_checklists&populate=sal.parent"}
                        edit={[ROLES.admin, ROLES.ufficio_tecnico, ROLES.PM].includes(global.user.ruolo) ? true : false}
                        editCondition={(row) => row.stato != "finito"}
                        delete={[ROLES.admin, ROLES.ufficio_tecnico, ROLES.PM].includes(global.user.ruolo) ? true : false}
                        add={[ROLES.admin, ROLES.ufficio_tecnico, ROLES.PM].includes(global.user.ruolo) ? true : false}
                        icon={"Personale"}
                        onDelete={(data) => this.deleteWorkers(data)}
                        onBeforeEdit={(data, oldData)=>this.checkMoveToFinished(data, oldData) }
                        onEdit={(data) => this.createFileSystem(data)}
                        onNew={(data) => { this.createFileSystem(data); this.createChecklist(data) }}
                        customAction={(ROLES.appalti == global.user.ruolo) ?
                            [
                                {
                                    icon: "folder",
                                    color: "info",
                                    function: this.openFileSystem
                                }
                            ]
                            :
                            [
                            {
                                icon: "visibility",
                                function: this.openDetail
                            },
                            {
                                icon: "folder",
                                color: "info",
                                function: this.openFileSystem
                            }
                        ]}
                    />
                </MDBox>

            </DashboardLayout>
        )
    }
}


